var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIconClicked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.67317 4.5112C7.88642 4.00866 9.18678 3.75 10.5 3.75C11.8132 3.75 13.1136 4.00866 14.3268 4.5112C15.5401 5.01375 16.6425 5.75035 17.5711 6.67893C18.4997 7.60752 19.2362 8.70991 19.7388 9.92316C20.2413 11.1364 20.5 12.4368 20.5 13.75H18C18 12.7651 17.806 11.7898 17.4291 10.8799C17.0522 9.96993 16.4997 9.14314 15.8033 8.4467C15.1069 7.75026 14.2801 7.19781 13.3701 6.8209C12.4602 6.44399 11.4849 6.25 10.5 6.25C9.51509 6.25 8.53982 6.44399 7.62987 6.8209C6.71993 7.19781 5.89314 7.75026 5.1967 8.4467C4.50026 9.14314 3.94781 9.96993 3.5709 10.8799C3.19399 11.7898 3 12.7651 3 13.75H0.5C0.5 12.4368 0.758657 11.1364 1.2612 9.92317C1.76375 8.70991 2.50035 7.60752 3.42893 6.67893C4.35752 5.75035 5.45991 5.01375 6.67317 4.5112Z",
    fill: "#6A84C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.67317 4.5112C7.88642 4.00866 9.18678 3.75 10.5 3.75C11.8132 3.75 13.1136 4.00866 14.3268 4.5112C15.5401 5.01375 16.6425 5.75035 17.5711 6.67893C18.4997 7.60752 19.2362 8.70991 19.7388 9.92316C20.2413 11.1364 20.5 12.4368 20.5 13.75H18C18 12.7651 17.806 11.7898 17.4291 10.8799C17.0522 9.96993 16.4997 9.14314 15.8033 8.4467C15.1069 7.75026 14.2801 7.19781 13.3701 6.8209C12.4602 6.44399 11.4849 6.25 10.5 6.25C9.51509 6.25 8.53982 6.44399 7.62987 6.8209C6.71993 7.19781 5.89314 7.75026 5.1967 8.4467C4.50026 9.14314 3.94781 9.96993 3.5709 10.8799C3.19399 11.7898 3 12.7651 3 13.75H0.5C0.5 12.4368 0.758657 11.1364 1.2612 9.92317C1.76375 8.70991 2.50035 7.60752 3.42893 6.67893C4.35752 5.75035 5.45991 5.01375 6.67317 4.5112Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.875 8.125V5.625H11.125V8.125H9.875ZM13.75 9L15.625 6.5L16.625 7.25L14.75 9.75L13.75 9Z",
    fill: "#6A84C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.875 8.125V5.625H11.125V8.125H9.875ZM13.75 9L15.625 6.5L16.625 7.25L14.75 9.75L13.75 9Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.93306 9.81694L4.43306 7.31694L5.31694 6.43306L7.81694 8.93306L6.93306 9.81694Z",
    fill: "#6A84C5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.93306 9.81694L4.43306 7.31694L5.31694 6.43306L7.81694 8.93306L6.93306 9.81694Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9337 12.6298C11.0601 11.9815 11.4428 9.90387 11.1731 9.81947C10.9033 9.73507 10.0335 11.6603 9.76785 12.265C9.71557 12.384 9.67028 12.5055 9.63976 12.6318C9.54556 13.0218 9.39126 13.8945 9.85278 14.039C10.3143 14.1834 10.685 13.3783 10.8298 13.0042C10.8768 12.883 10.9088 12.7573 10.9337 12.6298Z",
    fill: "#6A84C5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9337 12.6298C11.0601 11.9815 11.4428 9.90387 11.1731 9.81947C10.9033 9.73507 10.0335 11.6603 9.76785 12.265C9.71557 12.384 9.67028 12.5055 9.63976 12.6318C9.54556 13.0218 9.39126 13.8945 9.85278 14.039C10.3143 14.1834 10.685 13.3783 10.8298 13.0042C10.8768 12.883 10.9088 12.7573 10.9337 12.6298Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIconClicked);
export default __webpack_public_path__ + "static/media/dashboard-icon-clicked.63b1c81da0b90e1e8cd9433305cc99ce.svg";
export { ForwardRef as ReactComponent };